(function () {
  var KLAVIYO_REVISION = '2024-10-15';

  function text(data, name) {
    return (data.get(name) || '').toString().trim();
  }

  function checkedLabels(form, prefix) {
    var labels = [];
    form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function (el) {
      var name = el.getAttribute('name') || '';
      if (el.hasAttribute('data-need')) labels.push(el.getAttribute('data-need'));
      else if (name.indexOf(prefix) === 0) labels.push(name.slice(prefix.length, -1));
    });
    return labels;
  }

  function collect(form, type) {
    var data = new FormData(form);
    var needs = checkedLabels(form, 'contact[Need: ');
    var topics = checkedLabels(form, 'contact[About: ');

    return {
      type: type,
      name: text(data, 'contact[Name]'),
      email: text(data, 'contact[email]'),
      phone: text(data, 'contact[Phone]'),
      website: text(data, 'contact[Website]'),
      needs: needs.length ? needs : topics,
      platform: text(data, 'contact[Current platform]'),
      revenue: text(data, 'contact[Monthly revenue]'),
      budget: text(data, 'contact[Budget]'),
      timeline: text(data, 'contact[Timeline]'),
      heard_about: text(data, 'contact[Heard about us]'),
      starting_point: text(data, 'contact[Starting point]'),
      message: text(data, 'contact[Message]') || text(data, 'contact[body]'),
      source: form.id || 'ovxs-form',
      page_url: (typeof location !== 'undefined' && location.href) || '',
    };
  }

  function clean(object) {
    var out = {};
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      if (value === '' || value === undefined || (Array.isArray(value) && !value.length)) return;
      out[key] = value;
    });
    return out;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body),
    }).catch(function () {});
  }

  function sendToKlaviyo(klaviyoKey, metric, lead, firstName, lastName) {
    var properties = clean({
      lead_type: lead.type,
      website: lead.website,
      needs: lead.needs,
      current_platform: lead.platform,
      monthly_revenue: lead.revenue,
      budget: lead.budget,
      timeline: lead.timeline,
      heard_about: lead.heard_about,
      starting_point: lead.starting_point,
      message: lead.message,
      page_url: lead.page_url,
    });
    var profile = clean({ email: lead.email, first_name: firstName, last_name: lastName });
    var query = '?company_id=' + encodeURIComponent(klaviyoKey);

    post('https://a.klaviyo.com/client/profiles/' + query, {
      data: { type: 'profile', attributes: Object.assign({}, profile, { properties: clean({ website: lead.website, last_lead_type: lead.type }) }) },
    });

    post('https://a.klaviyo.com/client/events/' + query, {
      data: {
        type: 'event',
        attributes: {
          properties: properties,
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: { data: { type: 'profile', attributes: profile } },
        },
      },
    });
  }

  function sendToWebhook(webhookUrl, lead) {
    fetch(webhookUrl, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lead),
    }).catch(function () {});
  }

  function initContainer(container) {
    var form = container.querySelector('form');
    if (!form) return;

    var klaviyoKey = container.getAttribute('data-klaviyo-public-key');
    var webhookUrl = container.getAttribute('data-lead-webhook-url');
    var metric = container.getAttribute('data-lead-metric') || 'Requested Video Audit';
    var type = container.getAttribute('data-lead-type') || 'video_audit';
    if (!klaviyoKey && !webhookUrl) return;

    form.addEventListener('submit', function () {
      var lead = collect(form, type);
      if (!lead.email) return;

      var nameParts = lead.name.split(/\s+/).filter(Boolean);
      var firstName = nameParts.shift() || '';
      var lastName = nameParts.join(' ');

      if (klaviyoKey) sendToKlaviyo(klaviyoKey, metric, lead, firstName, lastName);
      if (webhookUrl) sendToWebhook(webhookUrl, lead);
    });
  }

  document.querySelectorAll('[data-klaviyo-public-key], [data-lead-webhook-url]').forEach(initContainer);
})();
